module.exports = __webpack_public_path__ + "static/media/shape1_5.fadc1130.obj";